import { atom } from 'nanostores'

const stored =
	typeof window !== 'undefined' &&
	localStorage &&
	localStorage.getItem('sharpseatRecentlyViewed')
const storedSearches =
	typeof window !== 'undefined' &&
	localStorage &&
	localStorage.getItem('sharpseatRecentSearches')

type RecentlyViewedPage = {
	title: string
	url: string
	type: 'event' | 'venue' | 'performer'
	id: string | number
}

export const recentlyViewed = atom<RecentlyViewedPage[]>(
	stored ? JSON.parse(stored) : [],
)

export const recentSearches = atom<string[]>(
	storedSearches ? JSON.parse(storedSearches) : [],
)

// export const recentlyViewed = atom<string[]>([])
// export const recentSearches = atom<string[]>([])

export const addRecentlyViewed = (item: RecentlyViewedPage) => {
	// return null
	try {
		let current = recentlyViewed.get()
		if (!current.find((i) => i.id === item.id && i.type === item.type)) {
			recentlyViewed.set([item, ...current].slice(0, 6))
			if (typeof window !== 'undefined' && localStorage) {
				localStorage &&
					localStorage.setItem(
						'sharpseatRecentlyViewed',
						JSON.stringify([item, ...current].slice(0, 6)),
					)
			}
		}
	} catch (error) {
		console.error(error)
	}
}

export const addRecentSearch = (item: any) => {
	// return null
	try {
		let current = recentSearches.get()
		if (!current.includes(item)) {
			recentSearches.set([item, ...current].slice(0, 4))
			localStorage &&
				localStorage.setItem(
					'sharpseatRecentSearches',
					JSON.stringify([item, ...current].slice(0, 4)),
				)
		}
	} catch (error) {
		console.error(error)
	}
}

recentlyViewed.subscribe(
	// (val) => browser && localStorage.setItem('recentlyViewed', JSON.stringify(val))
	(val) => {
		try {
			typeof window !== 'undefined' &&
				localStorage &&
				localStorage.setItem('sharpseatRecentlyViewed', JSON.stringify(val))
		} catch (error) {}
	},
)

recentSearches.subscribe(
	// (val) => browser && localStorage.setItem('recentlyViewed', JSON.stringify(val))
	(val) => {
		try {
			typeof window !== 'undefined' &&
				localStorage &&
				localStorage.setItem('sharpseatRecentSearches', JSON.stringify(val))
		} catch (error) {}
	},
)
